import { render, staticRenderFns } from "./UserAccountProfileSecurity.vue?vue&type=template&id=10776965&"
import script from "./UserAccountProfileSecurity.vue?vue&type=script&lang=js&"
export * from "./UserAccountProfileSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports